export default function About() {
  return (
    <>
      <p className="about">
        <img
          className="squidward"
          src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmedia0.giphy.com%2Fmedia%2FIzBpqKzHLtfTa%2Fsource.gif&f=1&nofb=1"
          alt="squidward"
        ></img>
        As a once busy Real Estate Professional turned Software Engineer,
        keeping track of chores in the household can be exhausting. I created
        this website for people to help keep track of chores that are completed,
        outstanding, or to add more chores to the list. The website is also
        great for children to stay on task with their weekly chore
        responsibilities. Happy cleaning!
      </p>
    </>
  );
}
